import PilotageInfoBar from './PilotageInfoBar'

export default PilotageInfoBar
